export default "__VITE_ASSET__DKUb$aSE__"